import { Injectable } from '@angular/core';
import { LoginService } from '../../login/login.service';
import { StorageService } from './../../shared/services/storage.service';
import { CartService } from './../../cart/cart.service';
import { CheckoutService } from '../../checkout/checkout.service';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class BloomreachService {
  isLoggedIn: boolean = false;
  paymentType = {
    [Constants.visa.key]: Constants.visa.value,
    [Constants.americanExpress.key]: Constants.americanExpress.value,
    [Constants.masterCard.key]: Constants.masterCard.value,
    [Constants.discoverCard.key]: Constants.discoverCard.value
  }
  constructor(
    private loginService: LoginService,
    private storageService: StorageService,
    private cartService: CartService,
    private checkoutService: CheckoutService,) {}

  ngAfterViewInit() {
    this.loginService.user.subscribe(user => {
      if (!!user) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    })
  }

  loadBloomreachIntegration() {
    const scriptContent = `
          !function(e,n,t,i,r,o){function s(e){if("number"!=typeof e)return e;var n=new Date;return new Date(n.getTime()+1e3*e)}var a=4e3,c="xnpe_async_hide";function p(e){return e.reduce((function(e,n){return e[n]=function(){e._.push([n.toString(),arguments])},e}),{_:[]})}function m(e,n,t){var i=t.createElement(n);i.src=e;var r=t.getElementsByTagName(n)[0];return r.parentNode.insertBefore(i,r),i}function u(e){return"[object Date]"===Object.prototype.toString.call(e)}o.target=o.target||"https://api.exponea.com",o.file_path=o.file_path||o.target+"/js/exponea.min.js",r[n]=p(["anonymize","initialize","identify","getSegments","update","track","trackLink","trackEnhancedEcommerce","getHtml","showHtml","showBanner","showWebLayer","ping","getAbTest","loadDependency","getRecommendation","reloadWebLayers","_preInitialize","_initializeConfig"]),r[n].notifications=p(["isAvailable","isSubscribed","subscribe","unsubscribe"]),r[n].segments=p(["subscribe"]),r[n]["snippetVersion"]="v2.7.0",function(e,n,t){e[n]["_"+t]={},e[n]["_"+t].nowFn=Date.now,e[n]["_"+t].snippetStartTime=e[n]["_"+t].nowFn()}(r,n,"performance"),function(e,n,t,i,r,o){e[r]={sdk:e[i],sdkObjectName:i,skipExperiments:!!t.new_experiments,sign:t.token+"/"+(o.exec(n.cookie)||["","new"])[1],path:t.target}}(r,e,o,n,i,RegExp("__exponea_etc__"+"=([\\w-]+)")),function(e,n,t){m(e.file_path,n,t)}(o,t,e),function(e,n,t,i,r,o,p){if(e.new_experiments){!0===e.new_experiments&&(e.new_experiments={});var l,f=e.new_experiments.hide_class||c,_=e.new_experiments.timeout||a,g=encodeURIComponent(o.location.href.split("#")[0]);e.cookies&&e.cookies.expires&&("number"==typeof e.cookies.expires||u(e.cookies.expires)?l=s(e.cookies.expires):e.cookies.expires.tracking&&("number"==typeof e.cookies.expires.tracking||u(e.cookies.expires.tracking))&&(l=s(e.cookies.expires.tracking))),l&&l<new Date&&(l=void 0);var d=e.target+"/webxp/"+n+"/"+o[t].sign+"/modifications.min.js?http-referer="+g+"&timeout="+_+"ms"+(l?"&cookie-expires="+Math.floor(l.getTime()/1e3):"");"sync"===e.new_experiments.mode&&o.localStorage.getItem("__exponea__sync_modifications__")?function(e,n,t,i,r){t[r][n]="<"+n+' src="'+e+'"></'+n+">",i.writeln(t[r][n]),i.writeln("<"+n+">!"+r+".init && document.writeln("+r+"."+n+'.replace("/'+n+'/", "/'+n+'-async/").replace("><", " async><"))</'+n+">")}(d,n,o,p,t):function(e,n,t,i,r,o,s,a){o.documentElement.classList.add(e);var c=m(t,i,o);function p(){r[a].init||m(t.replace("/"+i+"/","/"+i+"-async/"),i,o)}function u(){o.documentElement.classList.remove(e)}c.onload=p,c.onerror=p,r.setTimeout(u,n),r[s]._revealPage=u}(f,_,d,n,o,p,r,t)}}(o,t,i,0,n,r,e),function(e,n,t){var i;e[n]._initializeConfig(t),(null===(i=t.experimental)||void 0===i?void 0:i.non_personalized_weblayers)&&e[n]._preInitialize(t),e[n].start=function(i){i&&Object.keys(i).forEach((function(e){return t[e]=i[e]})),e[n].initialize(t)}}(r,n,o)}(document,"exponea","script","webxpClient",window,{
            target: "${Constants.bloomreachApiUrl}",
            token: "${Constants.bloomreachApiToken}",
            experimental: {
              non_personalized_weblayers: true
            },
            track: {
              google_analytics: false,
              // visits: true,
            },
            cookies: {
              expires: {
                tracking: 365 * 24 * 3600, // = 1 year
                ab_test: 30 * 24 * 3600, // = 30 days
              }
            },
          });
          exponea.start();
      `;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.text = scriptContent;
      document.head.appendChild(script);
  }

  trackEvent(eventName: string, eventData: any) {
    if (window['exponea']) {
      window['exponea'].track(eventName, eventData);
    }
  }
  
  identifyAndUpdateCustomerProperties(customerPropertiesData: any) {
    if (window['exponea']) {
      window['exponea'].identify({
        "email_id": customerPropertiesData.email
      },{
        "email": customerPropertiesData.email
      })

      window['exponea'].update(customerPropertiesData);
    }
  }

  trackProductView(productData: any) {
    this.trackEvent('view_item', productData);
  }

  trackCategoryView(categoryData: any) {
    this.trackEvent('view_category', categoryData);
  }

  trackPurchase(orderData: any) {
    this.trackEvent('purchase', orderData);
  }
  
  trackCheckout(checkoutData:any, orderSummary:any, defaultAddress:any, step_number:any) {
    var product_ids = [];
    var product_list = [];
    if(checkoutData.skus && checkoutData.skus.length) {
      checkoutData.skus.map((product:any) => {
        product_list.push(product.product);
        product_ids.push(product.product.id);
      })
    }
    const titles = [
      'INFO / SHIPPING',
      'BILLING',
      'PLACE ORDER'
    ]
    var paymentMethod = null;
    this.checkoutService.customerOrderData$.subscribe(
      customerOrder => {
        if(customerOrder && customerOrder.paymentMethod) {
          paymentMethod = customerOrder.paymentMethod;
        }
    })
    const data = {
      step_number: step_number,
      step_title: titles[step_number - 1],
      payment_type: '',
      shipping_type: orderSummary.shippingMethod,
      shipping_cost: orderSummary.shippingTotal,
      shipping_state: '',
      shipping_city: '',
      tax_value: orderSummary.salesTax,
      location: document.location.href,
      domain: document.location.hostname,
      product_list: product_list,
      product_ids: product_ids,
      variant_list: checkoutData.skus,
      variant_ids: checkoutData.skusList,
      total_quantity: checkoutData.skusQuantity.reduce((acc, val) => acc + val, 0),
      total_price: checkoutData.orderTotal,
      total_price_without_tax: orderSummary.orderSubtotal
    }

    if(defaultAddress) {
      data.shipping_state = defaultAddress.state;
      data.shipping_city = defaultAddress.city;
    } else {
      const address = JSON.parse(localStorage.getItem('selectedAddress'));
      if(address) {
        data.shipping_state = address.state;
        data.shipping_city = address.city;
      }
    }

    if(paymentMethod) {
      data.payment_type = this.paymentType[paymentMethod.cardType]
    }
    this.trackEvent('checkout', data);
  }

  trackCartUpdate(cartData: any, action:any = {}) {
    var cartResponse:any = {};
    if(cartData.skus && cartData.skus.length) {
      cartResponse = cartData.skus[0];
    } else {
      cartResponse = cartData;
    }
    const cartId = this.storageService.getItem('cartId');
    if(cartId) {
      if (this.isLoggedIn) {
        this.cartService.getShoppingCartById(cartId).subscribe(response => {
          this.callCartUpdateEvent(cartResponse, response.skus, action)
        })
      } else {
        this.cartService.getShoppingCartByIdWithoutAccount(cartId).subscribe((response) => {
          this.callCartUpdateEvent(cartResponse, response.skus, action)
        })
      }
    } else {
      this.callCartUpdateEvent(cartResponse, [], action)
    }
  }

  callCartUpdateEvent(cartResponse:any, shoppingCartData:any, action:any = {}) {
    var product_ids = [];
    var product_list = [];
    var variant_ids = [];
    if(shoppingCartData.length) {
      shoppingCartData.map((product:any) => {
        product_list.push(product.product);
        product_ids.push(product.product.id);
        variant_ids.push(product.id);
      })
    }
    const data = {
      action: action.action ? action.action : 'add',
      button_type: action.button_type ? action.button_type : 'Product detail',
      button_copy: action.button_copy ? action.button_copy : 'Add To Cart',
      page_type: action.page_type ? action.page_type : 'product',
      product_id: cartResponse.product.id,
      variant_id: cartResponse.id,
      title: cartResponse.product.name,
      category_level_1: cartResponse.product.category,
      category_level_2: cartResponse.product.subcategory,
      categories_path: cartResponse.product.category + ' > ' + cartResponse.product.subcategory,
      category_id: cartResponse.product.categoryId,
      categories_ids: [cartResponse.product.categoryId, cartResponse.product.subcategoryId],
      price: cartResponse.sellPrice,
      original_price: cartResponse.sellPrice,
      location: document.location.origin + '/cart/' + (localStorage.getItem('cartId') ? localStorage.getItem('cartId') : ''),
      domain: document.location.hostname,
      language: 'en',
      product_list: product_list,
      product_ids: product_ids,
      variant_list: shoppingCartData.length ? shoppingCartData : [],
      variant_ids: variant_ids,
      total_quantity: cartResponse.quantity,
      total_price: shoppingCartData.length ? shoppingCartData.map(product => product.quantity * product.sellPrice).reduce((a, b) => a + b).toFixed(2) : 0
    }
    this.trackEvent('cart_update', data);
  }

  trackClearCartUpdate(cartData: any) {
    var product_ids = [];
    var product_list = [];
    var variant_ids = [];
    cartData.map((product:any) => {
      product_list.push(product.product);
      product_ids.push(product.product.id);
      variant_ids.push(product.id);
    })
    const data = {
      action: 'empty',
      button_type: 'cart',
      button_copy: 'Clear Cart',
      page_type: 'cart',
      price: cartData.map(product => product.quantity * product.sellPrice).reduce((a, b) => a + b),
      discount_percentage: '',
      discount_value: '',
      original_price: cartData.map(product => product.quantity * product.sellPrice).reduce((a, b) => a + b),
      location: document.location.origin + '/cart/' + (localStorage.getItem('cartId') ? localStorage.getItem('cartId') : ''),
      domain: document.location.hostname,
      language: 'en',
      product_list: product_list,
      product_ids: product_ids,
      variant_list: cartData,
      variant_ids: variant_ids,
      total_quantity: cartData.map(product => product.quantity).reduce((a, b) => a + b),
      total_price: cartData.map(product => product.quantity * product.sellPrice).reduce((a, b) => a + b).toFixed(2),
      total_price_without_tax: ''
    }
    this.trackEvent('cart_update', data);
  }

  async trackConsent(notifyJDNews:any, placement:any, customerPropertiesData:any) {
    var location = document.location.href;

    if(customerPropertiesData) {
      this.identifyAndUpdateCustomerProperties(customerPropertiesData);
    }
    
    var ipAddress = '';
    await fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
        ipAddress = data.ip;
    })
    .catch(error => {
        console.log('Error:', error);
    });
    if(notifyJDNews) {
      const data = {
        action: 'accept',
        category: 'marketing',
        valid_until: 'unlimited',
        ip: ipAddress,
        message: 'Notify me about JD news, offers, and events',
        location: location,
        domain: document.location.hostname,
        language: 'en',
        timestamp: Date.now(),
        placement: placement,
      }
      this.trackEvent('consent', data);
    }
  }
}
